/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const Star = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        d="M11.2885 1.51283C11.5164 0.829057 12.4836 0.829057 12.7115 1.51283L15.04 8.5H22.25C22.9324 8.5 23.244 9.3235 22.7831 9.77851L22.7038 9.84712L16.885 14.269L19.469 21.8106C19.6973 22.4769 18.9726 23.0426 18.3922 22.7083L18.3104 22.6544L11.999 17.936L5.68956 22.6544C5.12542 23.0761 4.36467 22.56 4.50471 21.905L4.53096 21.8106L7.114 14.269L1.29618 9.84712C0.752862 9.4342 1.00311 8.59005 1.64539 8.50667L1.75 8.5H8.959L11.2885 1.51283ZM12 4.122L10.2115 9.48717C10.1094 9.79343 9.82282 10 9.5 10H3.977L8.45381 13.4029C8.68266 13.5768 8.78951 13.8637 8.73682 14.1402L8.7095 14.2431L6.737 19.998L11.5509 16.3993C11.7876 16.2223 12.1028 16.2027 12.3569 16.3403L12.4491 16.3993L17.262 19.998L15.2905 14.2431C15.1973 13.9712 15.2684 13.6734 15.4662 13.4732L15.5462 13.4029L20.022 10H14.5C14.213 10 13.9547 9.83678 13.8291 9.58542L13.7885 9.48717L12 4.122Z"
                        fill={color}
                    />
                </svg>
        );
    };
